import React from 'react'
import { useFormikContext } from 'formik'
import { SectionLayoutDialog } from 'shared'
import { DISCOUNT_TYPES } from 'utils/constants'

import { InstallmentCard } from '../InstallmentCard'

import { useStyles } from './InstallmentsDialog.style'

const InstallmentsDialog = ({ open, onClose, installments = [] }) => {
  const classes = useStyles()

  const { values } = useFormikContext()

  const getInstallmentOptions = () => {
    const installmentOptions = installments.sort((a, b) => a.number - b.number)

    if (!values.discountCode) return installmentOptions

    let remainingDiscount =
      values.discountCode?.discountType === DISCOUNT_TYPES.PERCENTAGE
        ? values.ticketType.price * (values.discountCode.percentage / 100)
        : values.discountCode?.fixedAmount ?? 0

    return [...installments]
      .sort((a, b) => b.number - a.number)
      .map((installment) => {
        if (remainingDiscount <= 0) return installment

        const applicableDiscount = Math.min(installment.amount, remainingDiscount)

        remainingDiscount -= applicableDiscount

        return {
          ...installment,
          discountApplied: applicableDiscount,
          originalAmount: installment.amount,
          amount: installment.amount - applicableDiscount
        }
      })
      .sort((a, b) => a.number - b.number)
  }

  const installmentOptions = getInstallmentOptions()

  return (
    <SectionLayoutDialog
      title='Plan de Cuotas'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <div className={classes.container}>
        {installmentOptions.map((installment) => (
          <InstallmentCard
            installment={installment}
            key={installment.id}
            hiddenTime={installment.number !== installments.length}
          />
        ))}
      </div>
    </SectionLayoutDialog>
  )
}

export default InstallmentsDialog
